const normalize = (value: string) =>
	value
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.toLowerCase()

export const matchesSearch = (search: string, values: Array<string | null | undefined>) => {
	const query = normalize(search.trim())

	return !query || values.some((value) => !!value && normalize(value).includes(query))
}
